
import { Component, Vue, Prop as prop, Watch as watch } from 'nuxt-property-decorator';
import { mapState } from 'vuex';
import { showErrorFlash, showFlash } from '~/lib/flash';

@Component({
    components: {
        btn: require('~/components/form/button').default,
    },
})
export default class QuestionListComponent extends Vue {

    @prop()
    public productId: number;
    loading = false;
    messages = [];

    mounted() {
        this.loadQuestions();
    }


    async loadQuestions() {
        this.messages = await this.$store.dispatch('RestRequest', {
            url: '/catalog/reviews/question',
            params: {
                offer_id: this.productId,
            }
        });
    }

    getFormattedDate(message) {
        const date = new Date(message.time);
        if (date.toDateString() !== new Date().toDateString()) {
            return `${date.toLocaleDateString()}, ${this.getFomattedTime(date)}`;
        }

        return `Сегодня, ${this.getFomattedTime(date)}`;
    }

    getFomattedTime(date: Date) {
        return `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
    }
}
